import { FormModal } from "../../../_components/Forms/FormModal";
import { useFieldArray } from "react-hook-form";
import { FormControl } from "../../../_components/Forms/FormControl";
import { HorizontalView } from "../../../_components/Abstractions/HorizontalView";
import { Dropdown } from "../../../_components/Abstractions/Dropdown";
import { WasteFormType } from "../../../domain/WasteFormType";
import { WasteExchangeType } from "../../../domain/WasteExchangeType";
import { ServicePricingType } from "../../../domain/ServicePricingType";
import { NumericControl } from "../../../_components/Forms/NumericControl";

export function EditRatePlanToOrder({ orderRatePlan, onRatePlanChange }) {
  return <FormModal
    buttonText="Ręczna zmiana cennika"
    formControls={<EditRatePlanToOrderForm/>}
    onSubmit={onRatePlanChange}
    defaultValues={orderRatePlan}
    // validationSchema={validationSchema}
    title="Dostosuj zmianę cennika"
    sizeModal="lg"
    successMessage="Zaktualizowano cennik ręcznie"
  />;
}

export const EditRatePlanToOrderForm = () => {
  const { fields: wastes } = useFieldArray({ name: "orderRatePlan.wastes" });
  const { fields: services } = useFieldArray({ name: "orderRatePlan.services" });
  const GetWasteFieldName = (fieldName, wasteIndex) => `orderRatePlan.wastes.[${wasteIndex}].${fieldName}`;
  const GetServiceFieldName = (fieldName, serviceIndex) => `orderRatePlan.services.[${serviceIndex}].${fieldName}`;

  return <div>
    <h5>Towary</h5>
    <hr/>
    {wastes.length > 0 && wastes.map((waste, idx) => <HorizontalView key={idx} columnsSize={[4, 3, 3, 2]}>
      <FormControl label="Towar" name={GetWasteFieldName("description", idx)} readonly/>
      <Dropdown label="Forma" items={WasteFormType} name={GetWasteFieldName("wasteForm", idx)} required={false} readonly/>
      <Dropdown label="Rozładunek" items={WasteExchangeType} name={GetWasteFieldName("exchangeType", idx)} readonly/>
      <NumericControl label="Cena" name={GetWasteFieldName("price", idx)}/>
      <FormControl label="Powód zmiany ceny" name={GetWasteFieldName("priceChangeReason", idx)} required={false}/>
    </HorizontalView>)}
    {/*{services.map(service => <div>{service}</div>)}*/}
    <h5>Usługi</h5>
    <hr/>
    {services.length > 0 && services.map((service, idx) => <HorizontalView key={idx} columnsSize={[4, 3, 3, 2]}>
      <FormControl label="Usługa" name={GetServiceFieldName("description", idx)} readonly/>
      <FormControl label="Towar" name={GetServiceFieldName("wasteDescription", idx)} required={false} readonly/>
      <Dropdown label="Jednostka" items={ServicePricingType} required={false} defaultValue="-" name={GetServiceFieldName("pricingType", idx)} readonly/>
      <FormControl label="Cena" name={GetServiceFieldName("price", idx)}/>
      <FormControl label="Powód zmiany ceny" name={GetServiceFieldName("priceChangeReason", idx)} required={false}/>
    </HorizontalView>)}
  </div>;
};